<div class="content">
  <div class="images">
    <img src="/images/about/package.webp" width="160" height="192" alt="Package Image" appSlideRight
      [slideRightDelay]="200" (click)="viewImage('/images/about/package.webp')" />
    <img src="/images/about/hangtag.webp" width="160" height="192" alt="hangtag Image" appSlideRight
      [slideRightDelay]="100" (click)="viewImage('/images/about/hangtag.webp')" />
  </div>

  <article>
    <h2 appSlideup [slideUpDelay]="100">Thoughtful From the First Touch</h2>
    <p appSlideup [slideUpDelay]="200">
      To us, packaging is part of the story. It is the first touch, the first
      impression, and the beginning of your connection with {{appname}}.
    </p>
    <p appSlideup [slideUpDelay]="300">
      Our hang tags and garment bags are designed with the same care as our
      clothing: minimal, modern, and thoughtful. They represent our belief that
      beauty lives in the details, and that every step of the experience should
      feel intentional.
    </p>
  </article>
</div>